import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { PanelLayout } from '@/components/common/PanelLayout';

import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { ChatPage } from '@/pages/ChatPage';
import { SubjectEditorPage } from '@/pages/SubjectEditorPage';
import { ManageUsersPage } from '@/pages/ManageUsersPage';
import { RoomBrowserPage } from '@/pages/RoomBrowserPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

function App() {
  const { isAuthenticated, initialized, initialize } = useAuthStore();

  React.useEffect(() => {
    initialize();
  }, [initialize]);

  if (!initialized) {
    return (
      <div className="min-h-[100svh] w-full bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
          <p className="mt-4 text-gray-600 dark:text-gray-400">Checking session...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[100svh] w-full bg-gray-50 dark:bg-gray-900">
      <Routes>
        <Route 
          path="/" 
          element={
            isAuthenticated ? (
              <Navigate to="/rooms" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />

        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/rooms" replace />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/register"
          element={
            isAuthenticated ? (
              <Navigate to="/rooms" replace />
            ) : (
              <RegisterPage />
            )
          }
        />

        {isAuthenticated ? (
          <Route path="/*" element={
            <PanelLayout>
              <Routes>
                <Route path="/rooms" element={<RoomBrowserPage />} />
                <Route path="/chat/:roomId" element={<ChatPage />} />
                <Route path="/subjects" element={<SubjectEditorPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/manage-users" element={<ManageUsersPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<Navigate to="/rooms" replace />} />
              </Routes>
            </PanelLayout>
          } />
        ) : (
          <>
            <Route path="/rooms" element={<Navigate to="/login" replace />} />
            <Route path="/chat/:roomId" element={<Navigate to="/login" replace />} />
            <Route path="/subjects" element={<Navigate to="/login" replace />} />
            <Route path="/profile" element={<Navigate to="/login" replace />} />
            <Route path="/manage-users" element={<Navigate to="/login" replace />} />
            <Route path="/settings" element={<Navigate to="/login" replace />} />
          </>
        )}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
